import {Doctor} from "./doctors/Doctor";

export function parseFormData(form) {
    let valueList = [];
    let value = {};
    let formData = new FormData(form);
    for (let [key, v] of formData.entries()) {
        if(key.includes("ignore")){
            continue
        }
        // Duplicate key, should create a new object
        if (Object.keys(value).includes(key)) {
            if(!Array.isArray(value[key])){
                value[key] = [value[key]];
            }
            value[key].push(v);
            /*valueList.push(value);
            value = {};*/
        }
        else if (!isNaN(v) && !isNaN(parseFloat(v))) {
            value[key] = +v;
        } else if (v === "true") {
            value[key] = true;
        } else if (v === "false") {
            value[key] = false;
        } else {
            value[key] = v;
        }

    }
    valueList.push(value);
    return valueList;
}

export function parseUtils(formRef) {
    return parseFormData(formRef?.current);
}


//export function fileToDataURL(id, file, filename = "", onload = ()=>{}, isThumbnail, visibleForUser, type) {
export function fileToDataURL(id, file, filename = "", onload = ()=>{}, isThumbnail,  type, visibleForUser) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        onload(id, reader.result, filename, isThumbnail, type, visibleForUser);
//        onload(id, reader.result, filename, isThumbnail, type);

    };/*
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };*/
}


export function getKeyByValue(object, value) {
    if (!object) {
        return "";
    }
    let key;
    Object.keys(object).some(function(k) {
        if (JSON.stringify(object[k]) === JSON.stringify(value) ) {
            key = k;
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            key = getKeyByValue(object[k], value);
            return key !== undefined;
        }
        return false;
    });
    return key;
}

export function findVal(object, key) {
    let value;
    Object.keys(object).some(function(k) {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findVal(object[k], key);
            return value !== undefined;
        }
        return false;
    });
    return value;
}

export function numberToString(number, digits = 1){
    if(!isNaN(number) && !isNaN(parseFloat(number))) {
        return number.toLocaleString('en-US', {
            minimumIntegerDigits: digits,
            useGrouping: false
        })
    } else {
        return "invalid number"
    }
}

export function extractHourFromDate(date){
    return `${numberToString(date.getHours(), 2)}:${numberToString(date.getMinutes(), 2)}`;
}

export function appendDoctorTelephonePrefix(doctor){
    let t_name = getKeyByValue(Doctor, Doctor.telephone_number);
    let p_name = getKeyByValue(Doctor, Doctor.prefix);
    doctor[t_name] = doctor[p_name] + " " + doctor[t_name];
    return doctor;
}
export function separateDoctorTelephonePrefix(doctor){
    let t_name = getKeyByValue(Doctor, Doctor.telephone_number);
    let p_name = getKeyByValue(Doctor, Doctor.prefix);
    doctor[p_name] = doctor[t_name].substring(0, doctor[t_name].indexOf(" "));
    doctor[t_name] = doctor[t_name].substring(doctor[t_name].indexOf(" ")).trim();
    return doctor;
}
